module.exports = __webpack_public_path__ + "static/martiniabout33-caacdfe23fea05eacabd1870db9fe0c9.png";